import styled, { css } from 'styled-components';
import * as colors from '@material-ui/core/colors';

const colorItem = (bg, font) => {
  return css`
    color: ${font};
    background: ${bg};
  `;
};

export const styles = () => ({
  itemTooltip: {
    'white-space': 'nowrap',
    'font-weight': 'bold',
    width: 'auto',
    display: 'inline-block',
    'line-height': '11px',
    padding: '6px 12px',
    background: '#000'
  }
});

export const StyledButton = styled.div`
  .tool-item {
    width: ${props => (props.size ? 42 * props.size : 42)}px;
    height: ${props => (props.size ? 42 * props.size : 42)}px;
    margin: 2px 0;
    &:hover {
      background: ${props => colorItem(colors[props.color[0]][props.color[1]], '#fff')};
      opacity: 0.9;
      ${props => props.selected && colorItem('#fff', colors[props.color[0]][props.color[2]])}
    }
    font-size: 15px;
    line-height: 14px;
    background: ${props => colorItem(colors[props.color[0]][props.color[1]], '#fff')};
    color: ${props => (props.txtColor ? props.txtColor : '#fff')};
    ${props => props.selected && colorItem('#fff', colors[props.color[0]][props.color[2]])}
  }
`;
